export default "__VITE_ASSET__ApR4jVPR__"